import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import GameModel from "../model/GameModel";
import Animation from "Engine/base/animation/Animation";
import WildSymbol from "./WildSymbol";
import EntryPoint from "Engine/EntryPoint";
import SoundManager from "Engine/soundManager/SoundManager";

export default class WildsContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.animations = [];

        this.init();
        this.addListeners();
    }

    init() {
        this.startX = this.x;
        this.startY = this.y;
    }

    changeState(value) {
        /*let scale = value === 1 ? 1 : 0.7678;
        let x = value === 1 ? 332 : 478;
        let y = value === 1 ? 159 : 152;
        if (EntryPoint.mobile) {
            y = value === 1 ? 287 : 280;
        }
        this.scale.set(scale, scale);
        this.position.set(x, y);*/
        let scale = value === 1 ? 1 : 0.7678;
        let x = value === 1 ? this.startX : this.startX + 146;
        let y = value === 1 ? this.startY : this.startY - 7;
        this.scale.set(scale, scale);
        this.position.set(x, y);
    }

    addListeners() {
        GlobalDispatcher.add('stateStart:minimalRollingState', this.updateAnimations, this);
        GlobalDispatcher.add('stateStart:requestRollingState', this.flyWilds, this);

        GlobalDispatcher.add('model:betChanged', this.onBetChanged, this);

        //GlobalDispatcher.add('stateStart:showWildsState', this.addAnimations, this);
        //GlobalDispatcher.add('stateEnd:selectHeroState', this.hide, this);
    }

    onBetChanged(event) {
        if (GameModel.wilds && GameModel.wilds.length > 0) {
            GameModel.wilds.forEach((wildsData) => {
                let animationIndex = this.animations.findIndex((animation) => {
                    return animation.pos.x === wildsData.wildCoordinates.x && animation.pos.y === wildsData.wildCoordinates.y;
                });
                if (animationIndex === -1) {
                    if (wildsData.bet === event.params) {
                        this.addWildAnimation(wildsData);
                    }
                } else {
                    if (wildsData.bet !== event.params) {
                        this.animations[animationIndex].destroy();
                        this.animations.splice(animationIndex, 1);
                    }
                }
            });
        }
    }

    flyWilds() {
        let animation = null;
        for(let i = 0; i < this.animations.length; i++) {
            animation = this.animations[i];
            if (animation.lockCount === 0) {
                if (animation.pos.y > 1) {
                    animation.flyUp();
                } else {
                    animation.flyDown();
                    this.addChild(animation);
                    this.animations.splice(i, 1);
                    i--;
                }
            } else {
                animation.decreaseLockCount();
            }
        }
    }

    updateAnimations(event) {
        if (GameModel.wilds && GameModel.wilds.length > 0) {
            GameModel.wilds.forEach((wildsData) => {
                let animationIndex = this.animations.findIndex((animation) => {
                    return animation.pos.x === wildsData.wildCoordinates.x && animation.pos.y === wildsData.wildCoordinates.y;
                });
                if (animationIndex === -1) {
                    this.addWildAnimation(wildsData);
                } else {
                    this.animations[animationIndex].data = wildsData;
                }
            });
        }
    }

    /*getData(position) {
        if (!position) {
            return null;
        }
        return GameModel.wilds.find((wildsData) => {
            return wildsData.wildCoordinates.x === position.x && wildsData.wildCoordinates.y === position.y;
        });
    }*/

    addWildAnimation(data) {
        let animation = new WildSymbol(data);
        animation.play('appear');
        SoundManager.play('sounds/mainGame/WildFlying', 1, false);
        this.addChild(animation);

        this.animations.push(animation);
    }

    reset() {
        this.animations.forEach((animation) => {
            animation.animation.destroy({children: true});
        });
        this.animations = [];
    }
}